import {PagesComponent} from "./pages/pages.component";
import {Route, RouterModule, Routes} from "@angular/router";
import {ModuleWithProviders} from "@angular/core";
import {AuthGuard} from "./guards/auth.guard";


export const routes: Routes = [
  {
    path: 'Login',
    loadChildren: () => import('./pages/login-container/login-container.module').then(m => m.LoginContainerModule)},
  {
    path: '',
    component: PagesComponent,
    children: [
      {path: 'Home', loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule ),  canActivate: [AuthGuard]},
      {path: 'JournalEntries', loadChildren: () => import('./pages/journal-entries/journal-entries.module').then(m => m.JournalEntriesModule ), canActivate: [AuthGuard]},
      {path: 'Payments', loadChildren: () => import('./pages/payments/payments.module').then(m => m.PaymentsModule ), canActivate: [AuthGuard]},
      {path: 'Users', loadChildren: () => import('./pages/users-list/users-list.module').then(m => m.UsersListModule ), canActivate: [AuthGuard]},
      {path: 'Permissions', loadChildren: () => import('./pages/users/users.module').then(m => m.UsersModule ), canActivate: [AuthGuard]},
      {
        path: '',
        redirectTo: '/Login',
        pathMatch: 'full'
      },
    ]
  },
];

export const AppRoutingModule: ModuleWithProviders<Route> = RouterModule.forRoot(routes, {
  useHash: true,
  onSameUrlNavigation: 'reload'
});
